"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _i18n = require("@lce/i18n");

var _slice = require("@lce/slice");

var _CartItem = _interopRequireDefault(require("../CartItem"));

var _useCart = _interopRequireDefault(require("../../../useCart/useCart"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CartList = function CartList() {
  var t = (0, _i18n.useTranslation)().t;
  var cart = (0, _useCart["default"])().cart;
  var hasItems = Object.keys(cart).length;
  return _react["default"].createElement(_slice.Box, {
    mb: 4
  }, hasItems ? (0, _map2["default"])(cart, function (item) {
    return _react["default"].createElement(_CartItem["default"], {
      item: item,
      key: item.menuItemCode
    });
  }) : _react["default"].createElement(_slice.Text, {
    "data-testid": "mini-cart__empty-label",
    fontSize: 6,
    mb: 7
  }, t('Header.Cart.Empty Cart')));
};

var _default = CartList;
exports["default"] = _default;